import io from 'socket.io-client';
import { config } from '../Configurations';
import { generateGymTvSocketChannelName } from './utils';
import { handleLoginService } from './handleLocalStorage';

const socketServerUrl = `${config.baseUrl}:6001`;
const events = {
    CONNECT: 'connect',
    SUBSCRIBE: 'subscribe',
    LEADERBOARD_UPDATED: 'App\\Events\\UserIsWorking',
    SCHEDULE_UPDATED: 'App\\Events\\ScheduleUpdated',
};

const subscribeToWorkout = (workoutId, callback) => {
    const socket = io(socketServerUrl);

    socket.on(events.CONNECT, () => {
        const channel = `workout.${workoutId}`;
        socket.emit(events.SUBSCRIBE, { channel });
    });

    socket.on(events.LEADERBOARD_UPDATED, (leaderboard, user) => {
        callback(user);
    });

    socket.connect();
};

const subscribeToLiveGymTv = (roomNumber, callback) => {
    const options = {
        auth: {
            headers: {
                Authorization: `Bearer ${handleLoginService.getAccessToken()}`,
            },
        },
    };

    const socket = io(socketServerUrl, options);

    socket.on(events.CONNECT, () => {
        const channel = generateGymTvSocketChannelName(handleLoginService.getUserId(), roomNumber);
        socket.emit(events.SUBSCRIBE, { channel, ...options });
    });

    socket.on(events.SCHEDULE_UPDATED, updateTrigger => callback(updateTrigger));

    socket.connect();
};

export { subscribeToWorkout, subscribeToLiveGymTv };



// WEBPACK FOOTER //
// ./src/Services/handleSocketConnection.js